import { useMemo } from 'react'
import { useStore } from '../models'
import { Route, usePathname } from 'expo-router'

export const gameRoutes: Route[] = [
  '/game',
  // '/game/my-first-game',
  // '/game/table-tour',
  // '/game/deal-the-flop',
  // '/game/raise-or-fold',
  '/game/statistics',
  '/game/leaderboard'
] as const

export const useIsInGame = () => {
  const { game } = useStore()

  const gameId = useMemo(() => game?.game?.gameId, [game?.game?.gameId])
  const myFirstGame = useMemo(() => game?.isMyFirstGame, [game?.isMyFirstGame])

  const pathname = usePathname()

  const inGameRoute = useMemo(() => {
    return gameRoutes.some((r) => r === pathname)
  }, [pathname])

  const isInGame = useMemo(() => {
    return Boolean(inGameRoute || gameId)
  }, [gameId, inGameRoute])

  const isMyFirstGame = useMemo(() => {
    return Boolean(myFirstGame || pathname.startsWith('/game/my-first-game'))
  }, [pathname, myFirstGame])

  return { isInGame, isMyFirstGame, inGameRoute }
}
